import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FlowStart } from '@common/analytics/model/flow-start';
import { AnalyticsSolverBase } from '@common/analytics/resolvers/analytics.solver.base';
import { FlowType, Registration } from '@spjp/model/registration';

@Injectable()
export class AnalyticsSolver extends AnalyticsSolverBase<Registration> {
    public solveProcessFlowStart(
        route: ActivatedRouteSnapshot,
        _: Registration,
    ): FlowStart {
        if (_?.flowType && _.flowType !== FlowType.Legacy) {
            return this.getProcessFlowStart(_.flowType);
        }
        if (route?.paramMap?.has('id')) return 'link';
        return 'person';
    }

    private getProcessFlowStart(flowType: FlowType): FlowStart {
        switch (flowType) {
            case FlowType.Battery:
                return 'product storage';
            case FlowType.SolarPanels:
                return 'product roof';
            case FlowType.SolarPanelsAndBattery:
                return 'product roof and storage';
        }
    }
}
